import { Link } from "react-router-dom";
import { Undo2 } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[var(--fcc-cream)] flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full fcc-card p-8 text-center">
        <Undo2 className="w-12 h-12 mx-auto text-[var(--fcc-ink-soft)]" />
        <h1 className="font-display text-2xl text-[var(--fcc-ink)] mt-4">Checkout canceled</h1>
        <p className="text-sm text-[var(--fcc-ink-soft)] mt-2">
          No worries — nothing was charged. You can pick a plan whenever you're ready.
        </p>
        <div className="mt-6 flex flex-col gap-2">
          <Link
            to="/app/settings/billing"
            data-testid="payment-cancel-retry"
            className="fcc-btn-primary text-sm py-2.5"
          >
            Back to billing
          </Link>
          <Link
            to="/app"
            className="text-xs text-[var(--fcc-muted)] hover:text-[var(--fcc-ink-soft)]"
          >
            or return to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
